/* eslint-disable no-console */
import React, {useEffect, useState} from 'react'
import {useForm} from 'react-hook-form'
import {toast} from 'react-toastify'
import {Button} from 'helpers/ui-components/Button'
import {useTranslation} from 'react-i18next'
import {Select2DropdownField} from 'helpers'
import {IFormData} from 'models/Common'
import {
 fetchLOB,
 fetchLOBDetails,
 updateLOB,
} from 'utils/api/auth/userManagementService'
import IAuth from 'models/Auth'
// import {ILogin} from 'models/Auth'

type ILOB = {
 lob?: string
}

type ILOBItem = {
 name: string
 value: string
}

type IProps = {
 userId: string
 activeTabId: number
 loggedInUser: IAuth | undefined
 userDetails?: IFormData | null
 setLoader: (newState: boolean) => void
 handleTabClick: (
  newState: number,
  isBackBtnClick: boolean
 ) => void
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const BusinessVertical = (props: IProps) => {
 const {t} = useTranslation()
 const isDisabled = false

 const isFpoCeo =
  props.userDetails?.user_category_key === 'FPO CEO'

 const [lobData, setLobData] = useState<ILOBItem[]>([])
 const lobList = [
  {
   id: 'input',
   name: t(
    'userManagement.activate.businessVertical.input'
   ),
  },
  {
   id: 'output',
   name: t(
    'userManagement.activate.businessVertical.output'
   ),
  },
  {
   id: 'finance',
   name: t(
    'userManagement.activate.businessVertical.finance'
   ),
  },
 ]
 const {
  control,
  handleSubmit,
  setValue,
  watch,
  formState: {errors},
 } = useForm({
  mode: 'all',
  reValidateMode: 'onChange',
  defaultValues: {lob: ''},
 })

 const getLOBDetails = async () => {
  props.setLoader(true)

  try {
   const res = await fetchLOBDetails(Number(props.userId))

   if (Array.isArray(res)) {
    setLobData(res)
   }
  } catch (error) {
   console.error('Error fetching LOB details:', error)
  } finally {
   props.setLoader(false)
  }
 }

 const getLOB = async () => {
  props.setLoader(true)
  const res: ILOB = await fetchLOB(Number(props.userId))
  if (res?.lob) {
   setValue('lob', res.lob)
  }
  props.setLoader(false)
 }
 async function submitFormData(formData: IFormData) {
  props.setLoader(true)

  try {
   if (!isFpoCeo && formData?.lob) {
    const res = await updateLOB(
     Number(props.userId),
     formData.lob.toString()
    )

    if (res) {
     toast.success(res)
    }
   }

   await props.handleTabClick(props.activeTabId, false)
  } finally {
   props.setLoader(false)
  }
 }

 useEffect(() => {
  if (isFpoCeo) {
   void getLOBDetails()
  } else {
   void getLOB()
  }
 }, [isFpoCeo])

 return (
  <>
   <div className='w-full'>
    <div className='text-[#171B1F] text-lg font-normal'>
     {t('userManagement.activate.businessVertical.title')}
    </div>
    <form
     method='POST'
     action=''
     onSubmit={handleSubmit(submitFormData)}
    >
     <div className='w-full mt-6'>
      <div className='grid md:grid-cols-3 gap-5 w-full mt-4 text-[#171B1F]'>
       {isFpoCeo ? (
        lobData
         .filter(
          (item) => item.value && item.value.trim() !== ''
         )
         .map((item) => (
          <div
           key={item.name}
           className='border border-[#DCE3EA] rounded-xl px-4 py-3 bg-[#F5F8FA] min-h-[78px] flex flex-col justify-center'
          >
           <p className='text-[#4E83E4] text-xs font-medium mb-1'>
            {item.name}
           </p>

           <p className='text-[#33393D] text-base font-medium break-words'>
            {item.value}
           </p>
          </div>
         ))
       ) : (
        <Select2DropdownField
         label={t(
          'userManagement.activate.businessVertical.lob'
         )}
         labelClassName='padding-0 text-[#4E83E4] text-xs !font-medium'
         className={`${
          isDisabled
           ? '!text-[#33393D] font-medium '
           : 'font-normal !text-[#33393D]'
         } boxed-select2 relative block text-lg border-0 !rounded-l-lg`}
         wrapperClassName='relative w-full'
         inputWrapperClassName='pl-4 py-2 px-4 '
         required={true}
         disabled={false}
         isClearable={false}
         isSearchable={true}
         control={control}
         customStyle={{
          transition: 'unset',
          boxShadow: 'unset',
          border: '0px',
          borderRadius: '0px',
          padding: '0px 0px 0px 0px',
          minHeight: 'auto',
         }}
         data={lobList}
         rules={{
          validate: {
           required: (v: string) => {
            if (v === '')
             return `${t('helperText.plsSelect')} ${t(
              'userManagement.activate.geoMapping.state'
             )}`
           },
          },
         }}
         id='lob'
         name='lob'
         OptionValueKey='id'
         OptionLabelKey='name'
         placeholder={`${t(
          'userManagement.activate.businessVertical.lob'
         )}`}
         errors={errors}
        />
       )}
      </div>
     </div>
     {(watch('lob') || isFpoCeo) && (
      <div className='w-full border-t border-[#E6EBF0] bg-white mt-6 py-6'>
       <div className='flex items-center justify-end pr-[72px]'>
        <Button
         type='button'
         disabled={false}
         onClick={() => {
          props.handleTabClick(props.activeTabId, true)
         }}
         color='white'
         className='text-center py-[9px] px-6 bg-white 
                        !rounded-lg text-base text-[#4E83E4] hover:bg-[#4E83E4] font-semibold border-[#4E83E4] mr-2'
        >
         {t('userManagement.activate.back')}
        </Button>
        <Button
         type='submit'
         disabled={false}
         color='blue'
         className='text-center py-[9px] px-6 bg-[#4E83E4] 
                        !rounded-lg text-base text-white font-semibold border-[#4E83E4]'
        >
         {t(
          'userManagement.activate.businessVertical.activateUser'
         )}
        </Button>
       </div>
      </div>
     )}
    </form>
   </div>
  </>
 )
}

export default BusinessVertical
